import { render, staticRenderFns } from "./VjsfDatePicker.vue?vue&type=template&id=06b595f8&scoped=true&"
import script from "./VjsfDatePicker.vue?vue&type=script&lang=js&"
export * from "./VjsfDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b595f8",
  null
  
)

export default component.exports